// DUIInsuranceFAQ.ts
// ----------------------------------------------------------------------------
// 10 Frequently Asked Questions for DUI Insurance
// Fields: id, question, answer, category, type
// ----------------------------------------------------------------------------

export interface IFAQDataDoc2025 {
  id: number;
  question: string;
  answer: string;
  category: string;
  type: string;
}

// import { IFAQDataDoc } from "../../App_v01_Interfaces";

export const WELDING_INSURANCE_FAQ_CONTENT_v01: IFAQDataDoc2025[] = 
[
  {
    id: 1,
    question: "What is welding insurance?",
    answer:
      "Welding insurance provides coverage for welding contractors and businesses against risks such as property damage, bodily injury, equipment loss, and liability claims related to welding operations.",
    category: "Basics",
    type: "General",
  },
  {
    id: 2,
    question: "Why do welders need insurance?",
    answer:
      "Welding involves high-risk work with heat, sparks, and heavy equipment. Insurance protects welders from financial losses due to accidents, injuries, or damage caused during jobs.",
    category: "Basics",
    type: "General",
  },
  {
    id: 3,
    question: "What types of coverage are included in welding insurance?",
    answer:
      "Common coverages include general liability, commercial property, tools and equipment coverage, commercial auto, and workers’ compensation.",
    category: "Coverage",
    type: "General",
  },
  {
    id: 4,
    question: "Does welding insurance cover mobile welding businesses?",
    answer:
      "Yes. Mobile welders can be covered for liability, equipment in transit, and on-site risks while working at customer locations or job sites.",
    category: "Coverage",
    type: "Mobile",
  },
  {
    id: 5,
    question: "How much does welding insurance cost?",
    answer:
      "The cost depends on factors such as business size, type of welding work, number of employees, annual revenue, and claims history. Premiums typically range from a few hundred for a small shop/one man show to several thousand dollars per year.",
    category: "Costs",
    type: "General",
  },
  {
    id: 6,
    question: "Does insurance cover welding equipment and tools?",
    answer:
      "Yes. Specialized coverage, often called inland marine or equipment insurance, protects welding machines, torches, and other tools against theft, fire, or accidental damage.",
    category: "Coverage",
    type: "Equipment",
  },
  {
    id: 7,
    question: "Is welding insurance required by law?",
    answer:
      "While not always required by law, many states mandate workers’ compensation if employees are hired. In addition, many clients and job contracts require proof of liability insurance.",
    category: "Requirements",
    type: "Legal",
  },
  {
    id: 8,
    question: "Can welding insurance help me get more jobs?",
    answer:
      "Yes. Many contractors, municipalities, and industrial clients require welders to carry liability insurance before awarding work contracts, making coverage a competitive advantage.",
    category: "Business",
    type: "Opportunities",
  },
  {
    id: 9,
    question: "Does welding insurance cover fire damage caused on a job site?",
    answer:
      "Yes, general liability insurance can cover accidental fire damage caused during welding operations, protecting you from costly claims.",
    category: "Coverage",
    type: "Risk",
  },
  {
    id: 10,
    question: "How can I get welding insurance?",
    answer:
      "You can get welding insurance by contacting an insurance agent or broker who specializes in contractor policies. They can compare multiple carriers and customize coverage to fit your business.",
    category: "Getting Started",
    type: "General",
  },
]

